export default __webpack_public_path__ + "noItems.bdf6b711d6d37d85719831f0f78dec93.svg";